import React from 'react';
import PageSpinner from './PageSpinner';

let LoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <PageSpinner />;
  }
  // Handle the error state
  else if (error) {
    console.log('Error in LoadingComponent');
    console.log(error);
    return <div>{L10n.t('global.error_info.page_load_failed')}</div>;
  } else {
    return null;
  }
};

export { LoadingComponent };
